import React, { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "../src/pages/home";
import Home1 from "../src/pages/home1";
import Pricing from "../src/pages/pricing";
import Dashboard from "../src/pages/dashboard";
import Knowledgebase from "../src/pages/knowledgebase";
import Faq from "../src/pages/faq";
import Contact from "../src/pages/contact";
import About from "../src/pages/about";
import Login from "../src/pages/login";
import Aistoryteller from "../src/pages/aistoryteller";
import Navbar from "./layout/Navbar";
import Success from "./pages/success";
import Cancel from "./pages/cancel";
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
const routes = [
  { path: "/", element: <Home /> },
  { path: "/home1", element: <Home1 /> },

  { path: "/pricing", element: <Pricing /> },

  { path: "/dashboard", element: <Dashboard /> },

  { path: "/knowledgebase", element: <Knowledgebase /> },
  { path: "/faq", element: <Faq /> },
  { path: "/contact", element: <Contact /> },

  { path: "/about", element: <About /> },

  { path: "/login", element: <Login /> },
  { path: "/register", element: <Login /> },

  { path: "/aistoryteller", element: <Aistoryteller /> },
  { path: "/aistoryteller/:userId", element: <Aistoryteller /> },

  { path: "/stripe/success", element: <Success /> },
  { path: "/stripe/success?session_id", element: <Success /> },
  { path: "/stripe/cancel", element: <Cancel /> },
  { path: "/thank-you-page", element: <Home /> },
];

const Navigation = () => (
  <Routes>
    {routes.map(({ path, element }) => (
      <Route key={path} path={path} element={element} />
    ))}
  </Routes>
);

function App() {
  return (
    <HelmetProvider>
      <div>
        <BrowserRouter>
          <ScrollToTop />
          <Navigation />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
